import { render, staticRenderFns } from "./youtubePlayer.vue?vue&type=template&id=2c0bb5a9&scoped=true&lang=pug&"
import script from "./youtubePlayer.vue?vue&type=script&lang=js&"
export * from "./youtubePlayer.vue?vue&type=script&lang=js&"
import style0 from "./youtubePlayer.vue?vue&type=style&index=0&id=2c0bb5a9&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0bb5a9",
  null
  
)

export default component.exports